import { IDocuments } from '@llws/lift-entity-interfaces';
import { IQueryCommandOptions } from '@/shared';
import { StoreBaseImplementation } from '@/shared/classes/store-base-implementation';

const adminGatewayResourcePath: string = '/website-api/sites/:param/documents';
const listViewName: string = '';
const showLogging: boolean = false;
const defaultGetListFilters: IQueryCommandOptions = {};
const defaultGetSingleFilters: IQueryCommandOptions = {};

const base = new StoreBaseImplementation<IDocuments>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

export default {
  namespaced: base.namespaced, // 'documents/'

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,
  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,
  },
};
